// extracted by mini-css-extract-plugin
export default {"container":"PagePopup__container--2-0"};